import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private apiUrl = `${environment.apiUrl}/users`;   

  constructor(private http: HttpClient) { }
  
  getUsersPaginado(options: {
      page?: number;
      limit?: number;
      sortBy?: string;
      sortOrder?: string;
      search?: string;
      profile?: string;
      clientId?: number;
      export?: boolean;
    }): Observable<any> {
      
      let params = new HttpParams();
      
      if (options.export) {
        params = params.set('export', 'true');        
      } else {
        // Solo añadir paginación si NO es exportación
        if (options.page) params = params.set('page', options.page.toString());
        if (options.limit) params = params.set('limit', options.limit.toString());
      }

      // Parámetros de ordenamiento (se envían siempre)
      if (options.sortBy) params = params.set('sortBy', options.sortBy);
      if (options.sortOrder) params = params.set('sortOrder', options.sortOrder);
      
      // Parámetros de filtro (se envían siempre)
      if (options.search) params = params.set('search', options.search);
      if (options.profile) params = params.set('profile', options.profile);
      if (options.clientId) params = params.set('clientId', options.clientId.toString());

      // El endpoint GET /users (findAll en el controller) ya acepta 'export'
      return this.http.get<any>(this.apiUrl, { params });
    }

  getUsers(company?: string): Observable<any[]> {
    let params = new HttpParams();
    if (company) {
      params = params.set('company', company);
    }
    return this.http.get<any[]>(this.apiUrl, { params });
  }

  updateUser(user: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${user.id}`, user);
  }

  deleteUser(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  /**
   * Reactiva un usuario que se encontraba dado de baja (eliminado lógico)
   * @param id ID del usuario a reactivar
   */
  restaurarUsuario(id: number): Observable<void> {
    // Se envía un body vacío {} ya que es un PUT, pero la acción real la determina el ID en la URL
    return this.http.put<void>(`${this.apiUrl}/${id}/restaurar`, {});
  }
  
  getAllTecnicos(page: number = 1, limit: number = 10): Observable<any> {
    const url = `${this.apiUrl}/tecnicos`;
    const params = new HttpParams()
        .set('page', page.toString())
        .set('limit', limit.toString());
    
    console.log('URL de la petición:', url);
    return this.http.get(url, { params }).pipe(
        tap((response: any) => console.log('Respuesta del servidor:', response)),
        catchError((error: any) => {
            console.error('Error al obtener técnicos:', error);
            throw error;
        })
    );
  }
  
  getUserById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  // Se implementa método faltante para consultar los usuarios asociados a un cliente
  getAllUsersByClient(clientId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/client/${clientId}`); 
  }
}
